import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronTriangleDownMedium"><Path d="M12 17.5625L4.86523 9H19.1348L12 17.5625Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleDownMedium;
